import React from 'react';
import StaticPageLayout from '../components/StaticPageLayout';

const PlagiarismPage = () => (
  <StaticPageLayout
    overline="Publication Ethics"
    title="Plagiarism & Originality"
    description="All manuscripts submitted to MAH Quantum Research Institute must represent original, unpublished work. This policy outlines what constitutes plagiarism and how cases are handled."
    breadcrumbs={[{ label: 'Publication Ethics', path: '/publication-ethics' }, { label: 'Plagiarism & Originality', path: '/plagiarism' }]}
  >
    <div className="space-y-10">
      <section>
        <h2 className="font-serif text-2xl font-semibold text-[#1F1F1F] mb-4 pb-3 border-b border-[#E5E7EB]">Originality Requirement</h2>
        <p className="text-[#4B5563] leading-relaxed mb-3">
          Submitted manuscripts must be entirely original. By submitting, authors confirm that the work has not been published previously in any language, is not under consideration for publication elsewhere, and does not infringe upon any existing copyright.
        </p>
        <p className="text-[#4B5563] leading-relaxed">
          All text, data, figures, and ideas presented in the manuscript must either be the original work of the authors or be properly attributed to the original source with appropriate citation.
        </p>
      </section>

      <section>
        <h2 className="font-serif text-2xl font-semibold text-[#1F1F1F] mb-5 pb-3 border-b border-[#E5E7EB]">Forms of Plagiarism</h2>
        <div className="space-y-2">
          {[
            { form: 'Direct Plagiarism', desc: 'Copying text from another source verbatim without quotation marks and attribution.' },
            { form: 'Paraphrase Plagiarism', desc: 'Rephrasing another author\'s work without proper attribution, presenting the ideas as one\'s own.' },
            { form: 'Self-Plagiarism', desc: 'Reusing substantial portions of one\'s own previously published work without disclosure or citation.' },
            { form: 'Data Fabrication', desc: 'Inventing or misrepresenting data, results, or findings. This constitutes research fraud, not merely plagiarism.' },
            { form: 'Image Manipulation', desc: 'Inappropriately altering figures, microscopy images, or other visual data to misrepresent results.' },
          ].map(item => (
            <div key={item.form} className="flex gap-3 border border-[#E5E7EB] p-4 bg-white text-sm">
              <span className="font-semibold text-[#374151] flex-shrink-0 w-40">{item.form}</span>
              <span className="text-[#6B7280] leading-relaxed">{item.desc}</span>
            </div>
          ))}
        </div>
      </section>

      <section>
        <h2 className="font-serif text-2xl font-semibold text-[#1F1F1F] mb-4 pb-3 border-b border-[#E5E7EB]">Screening & Consequences</h2>
        <p className="text-[#4B5563] leading-relaxed mb-3">
          Submissions are screened for originality during the editorial review stage. Manuscripts identified as containing plagiarised content will be immediately rejected and the submitting author notified. Depending on the severity, the matter may be escalated to the author's institution.
        </p>
        <p className="text-[#4B5563] leading-relaxed">
          For post-publication cases, a formal retraction notice will be issued. Authors found to have engaged in plagiarism may be barred from future submissions to the platform.
        </p>
      </section>
    </div>
  </StaticPageLayout>
);

export default PlagiarismPage;
